export default __webpack_public_path__ + "static/media/minusLight.206547b0.svg";